<template>
  <div class="mensalista-table">
    <table class="table table-borderless">
      <thead class="table-header">
        <tr>
          <th scope="col-1">
            Ativo
          </th>
          <th scope="col-3">
            CPF/CNPJ
          </th>
          <th scope="col-5">
            Nome
          </th>
          <th scope="col" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="mensalista in mensalistasStore"
            :key="mensalista.mensalista_id"
            class="table-linha">
          <td class="col-1 pt-4">
            <div class="custom-control custom-switch">
              <input :id="mensalista.mensalista_id"
                     type="checkbox"
                     :checked="mensalista.ativo"
                     class="custom-control-input"
                     @click="handlerStatus(mensalista)">
              <label class="custom-control-label"
                     for="customSwitch1"
                     @click="handlerStatus(mensalista)" />
            </div>
          </td>
          <td class="col-3  pt-4">
            <input v-mask="['###.###.###-##', '##.###.###/####-##']" 
                   class="input-cpf"
                   type="text"
                   readonly
                   :value="mensalista.cpf_cnpj">
          </td>
          <td class="col-5  pt-4">
            {{ mensalista.nome_empresa }}
          </td>
          <td class="d-flex justify-content-end">
            <AddMensalista :prop-mensalista="mensalista" />
            <ModalMensalista :prop-mensalista="mensalista" /> 
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

  // Services
  import MensalistaService from '../mensalistaService'

  // Componentes
  import AddMensalista from '../AddMensalista/AddMensalista.vue'
  import ModalMensalista from '../ModalMensalista/ModalMensalista.vue'

  export default ({
    name: 'TabelaMensalistas',
    components: {
      AddMensalista,
      ModalMensalista,
    },
    data () {
      return {
        mensalistas: []
      }
    },
    computed: {
      mensalistasStore () {
        return this.$store.state.frenteCaixa.mensalistas
      },
    },
    methods: {
      async handlerStatus (mensalista) {
        let item = this.mensalistasStore.find(item => item.mensalista_id === mensalista.mensalista_id)
        item.ativo = !item.ativo
        await this.salvarStatus(mensalista.mensalista_id)
      },
      async salvarStatus (id) {
        loader({text: 'Salvando mensalista', active: true})
        try {
          await MensalistaService.mudatStatus(id)
          displayMessage('success', 'Status alterado com sucesso.')
        } catch (err) {
          console.log('TabelaMensalista', err)
          displayMessage('error', 'Ocorreu um erro ao alterar o status, tente novamente.')
        } finally {
          loader({text: null, active: false})
        }
      },
    }
  })
</script>

<style scoped>
.mensalista-table {
  margin-left: 40px;
  margin-right: 18px;
  margin-top: 20px;
}
.table-header {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  background-color: #00C0A7;
  border: solid 1px #00C0A7;
  font-size: 18px;
}
.table-linha {
  border: solid 1px #cacbcb;
  transition: .3s;
}
.table-linha:hover {
  background-color: #f6f6f6;
  cursor: pointer;
  transition: .3s;
}
.icone {
  color: red;
  fill: gray;
}
.input-cpf {
  border: none;
  outline: none;
  background-color: transparent;
}
</style>
